<template>
  <el-dialog
    :title="title"
    @closed="_closed"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="800px"
    custom-class="task-detail-dialog"
    :modal-append-to-body="false"
  >
    <div class="dialog-content">
      <el-tabs v-model="activeTab" type="border-card" class="fixed-tabs">
        <!-- 第一个Tab：任务详情 -->
        <el-tab-pane label="任务详情" name="base">
          <div class="tab-content-scroll">
            <div class="info-section">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="label">任务ID：</span>
                    <span>{{task.task_id}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="label">地点名称：</span>
                    <span>{{task.location_name}}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="label">工人姓名：</span>
                    <span>{{task.worker_name}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="label">打卡时间：</span>
                    <span>{{task.clock_in_time}}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="label">提交时间：</span>
                    <span>{{task.submit_time || '-'}}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="detail-item">
                    <span class="label">当前状态：</span>
                    <el-tag :type="getStatusType(task.status)">{{ getStatusText(task.status) }}</el-tag>
                  </div>
                </el-col>
              </el-row>
            </div>

            <el-divider></el-divider>

            <!-- 兼容旧数据：单图对比（当没有多比对点数据时显示） -->
            <el-row :gutter="16" v-if="(!pointResults || pointResults.length === 0) && (standardImageUrl || images.length > 0)">
              <!-- 标准图片 - 左边 -->
              <el-col :span="12" v-if="standardImageUrl">
                <el-card>
                  <template #header>
                    <div class="card-header">标准清洁图片（基准图）</div>
                  </template>
                  <div class="image-container">
                    <img :src="standardImageUrl" alt="标准清洁图片" class="detail-image">
                  </div>
                </el-card>
              </el-col>
              <!-- 工人上传图片 - 右边 -->
              <el-col :span="12" v-if="images.length > 0">
                <el-card>
                  <template #header>
                    <div class="card-header">工人上传图片</div>
                  </template>
                  <div class="image-grid">
                    <div v-for="(img, index) in images" :key="index" class="image-item">
                      <img :src="img.image_url" alt="上传图片" class="detail-image">
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>

            <el-divider v-if="(!pointResults || pointResults.length === 0)"></el-divider>

            <el-card>
              <template #header>
                <div class="card-header">AI审核结果</div>
              </template>
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">AI打分：</span>
                    <span :class="task.ai_pass ? 'text-green' : 'text-red'">{{task.ai_score !== null ? task.ai_score + '分' : '-'}}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">AI结论：</span>
                    <span :class="task.ai_pass ? 'text-green' : 'text-red'">{{task.ai_score === null ? '-' : (task.ai_pass ? '合格' : '不合格')}}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="detail-item">
                    <span class="label">AI原因：</span>
                    <span>{{task.ai_reason || '-'}}</span>
                  </div>
                </el-col>
              </el-row>

              <div class="margin-top" v-if="task.status === 1">
                <el-button type="warning" @click="triggerAiAudit" :loading="triggerLoading">重新触发AI审核</el-button>
              </div>
            </el-card>
          </div>
        </el-tab-pane>

        <!-- 第二个Tab：比对点详细审核结果 -->
        <el-tab-pane label="比对点审核结果" name="point" v-if="pointResults && pointResults.length > 0">
          <div class="tab-content-scroll">
            <!-- 汇总信息 -->
            <el-card class="summary-card">
              <template #header>
                <div class="card-header">审核汇总</div>
              </template>
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="summary-item">
                    <span class="summary-label">加权总分：</span>
                    <span class="summary-value" :class="task.ai_pass ? 'text-green' : 'text-red'">{{task.ai_score}}分</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="summary-item">
                    <span class="summary-label">通过数量：</span>
                    <span class="summary-value text-green">{{passCount}}/{{pointResults.length}}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="summary-item">
                    <span class="summary-label">不通过数量：</span>
                    <span class="summary-value text-red">{{failCount}}/{{pointResults.length}}</span>
                  </div>
                </el-col>
              </el-row>
            </el-card>

            <!-- 比对点详细列表 -->
            <el-row :gutter="16" class="point-list">
              <el-col :span="24" v-for="(point, index) in pointResults" :key="index">
                <el-card class="point-card" :shadow="'hover'">
                  <template #header>
                    <div class="point-header">
                      <span class="point-name">
                        <span class="point-index">{{index + 1}}</span>
                        {{ point.pointName }}
                      </span>
                      <el-tag :type="point.isPass ? 'success' : 'danger'" size="small">
                        {{ point.score }}分 (权重{{ point.weight }}%)
                      </el-tag>
                    </div>
                  </template>
                  <el-row :gutter="8">
                    <el-col :span="12">
                      <div class="img-label">标准参考图</div>
                      <div class="point-image-container">
                        <img :src="point.standardImageUrl" alt="标准参考图" class="point-image">
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="img-label">工人上传</div>
                      <div class="point-image-container">
                        <img :src="point.userImageUrl" alt="上传图片" class="point-image">
                      </div>
                    </el-col>
                  </el-row>
                  <!-- AI检测结果说明 -->
                  <div class="ai-result-box" :class="{ 'is-pass': point.isPass, 'is-fail': !point.isPass }">
                    <div class="ai-result-title">
                      <i :class="point.isPass ? 'el-icon-success' : 'el-icon-warning'"></i>
                      AI检测结果说明
                    </div>
                    <div class="ai-result-content">
                      {{ point.reason || '检测通过' }}
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>

        <!-- 第三个Tab：申诉信息 -->
        <el-tab-pane label="申诉信息" name="appeal" v-if="appealInfo">
          <div class="tab-content-scroll">
            <el-descriptions :column="1" border>
              <el-descriptions-item label="申诉人">{{ appealInfo.worker_name }}</el-descriptions-item>
              <el-descriptions-item label="申诉时间">{{ appealInfo.create_time }}</el-descriptions-item>
              <el-descriptions-item label="申诉理由">{{ appealInfo.appeal_reason }}</el-descriptions-item>
              <el-descriptions-item label="申诉状态">
                <el-tag :type="getAppealStatusType(appealInfo.status)">{{ getAppealStatusText(appealInfo.status) }}</el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="申诉判定评分" v-if="appealInfo.appeal_score !== null">
                {{ appealInfo.appeal_score }}分
              </el-descriptions-item>
              <el-descriptions-item label="处理人" v-if="appealInfo.handle_user_name">{{ appealInfo.handle_user_name }}</el-descriptions-item>
              <el-descriptions-item label="处理时间" v-if="appealInfo.handle_time">{{ appealInfo.handle_time }}</el-descriptions-item>
              <el-descriptions-item label="处理备注" v-if="appealInfo.handle_remark">{{ appealInfo.handle_remark }}</el-descriptions-item>
            </el-descriptions>

            <!-- 申诉图片 -->
            <el-card v-if="appealInfo.image_urls" class="margin-top">
              <template #header>
                <div class="card-header">申诉补充图片</div>
              </template>
              <div class="image-grid">
                <div v-for="(img, index) in appealImageList" :key="index" class="image-item">
                  <img :src="img" alt="申诉图片" class="detail-image">
                </div>
              </div>
            </el-card>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="_cancle">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    passCount() {
      return this.pointResults.filter(p => p.isPass).length
    },
    failCount() {
      return this.pointResults.filter(p => !p.isPass).length
    },
    appealImageList() {
      if (!this.appealInfo || !this.appealInfo.image_urls) return []
      return this.appealInfo.image_urls.split(',').filter(url => url.trim())
    }
  },
  data() {
    return {
      title: '',
      visible: true,
      taskId: 0,
      task: {},
      images: [],
      pointResults: [],
      standardImageUrl: '',
      triggerLoading: false,
      activeTab: 'base',
      appealInfo: null
    }
  },
  created() {
    if (this.data && this.data.taskId) {
      this.taskId = this.data.taskId
    }
  },
  mounted() {
    this.loadDetail()
  },
  methods: {
    _closed() {
      this.onclosed()
    },
    _cancle() {
      this.visible = false
      this.cancle && this.cancle()
    },
    handleClose() {
      this._cancle()
    },
    async loadDetail() {
      if (!this.taskId) return
      const res = await this.$lgh.get('api/clean/task/info', { taskId: this.taskId })
      this.task = res.task || res
      this.images = res.images || []
      this.pointResults = res.pointResults || []
      if (this.task.locationInfo) {
        this.standardImageUrl = this.task.locationInfo.standard_image_url
      }

      // 如果有申诉状态，加载申诉详情
      if (this.task.appeal_status && this.task.appeal_status > 0) {
        try {
          const appealRes = await this.$lgh.get('api/clean/task/appeal/info', { taskId: this.taskId })
          this.appealInfo = appealRes
        } catch (err) {
          console.warn('加载申诉信息失败', err)
        }
      }
    },
    getStatusType(status) {
      const map = { 0: 'info', 1: 'warning', 2: 'success', 3: 'danger', 5: 'warning', 6: 'success', 7: 'danger' }
      return map[status] || 'info'
    },
    getStatusText(status) {
      const map = { 0: '已打卡未提交', 1: '已提交待审核', 2: 'AI审核通过', 3: 'AI审核不通过', 5: '申诉中', 6: '申诉通过', 7: '申诉不通过' }
      return map[status] || '未知'
    },
    getAppealStatusType(status) {
      const map = { 1: 'warning', 2: 'success', 3: 'danger' }
      return map[status] || 'info'
    },
    getAppealStatusText(status) {
      const map = { 1: '申诉中', 2: '申诉通过', 3: '申诉不通过' }
      return map[status] || '未知'
    },
    async triggerAiAudit() {
      this.triggerLoading = true
      try {
        await this.$lgh.get('api/clean/task/trigger-ai-audit', { taskId: this.taskId })
        this.$message.success('已触发AI审核')
        setTimeout(() => this.loadDetail(), 1000)
      } catch (err) {
        this.$message.error(err.message || '触发失败')
      } finally {
        this.triggerLoading = false
      }
    }
  }
}
</script>

<style>
.task-detail-dialog {
  height: 80vh;
  margin: 10vh auto !important;
  display: flex;
  flex-direction: column;
}
.task-detail-dialog .el-dialog__header {
  flex-shrink: 0;
}
.task-detail-dialog .el-dialog__body {
  padding: 0 !important;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.task-detail-dialog .el-dialog__footer {
  flex-shrink: 0;
  padding: 10px 20px;
}
</style>

<style scoped>
.dialog-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ========== 核心修复：Tab 高度 + 滚动 ========== */
.fixed-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: none;
  overflow: hidden;
}
.fixed-tabs >>> .el-tabs__header {
  margin: 0;
  flex-shrink: 0;
  background: #fafafa;
}
.fixed-tabs >>> .el-tabs__content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.fixed-tabs >>> .el-tab-pane {
  height: 100% !important;
}
/* ============================================= */

.tab-content-scroll {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  box-sizing: border-box;
}

/* 滚动条美化 */
.tab-content-scroll::-webkit-scrollbar { width: 6px; }
.tab-content-scroll::-webkit-scrollbar-thumb { background: #ccc; border-radius: 3px; }
.tab-content-scroll::-webkit-scrollbar-track { background: #f5f5f5; }

.info-section { padding: 10px 0; }
.detail-item { padding: 8px 0; }
.detail-item .label { font-weight: bold; color: #606266; }
.text-green { color: #67c23a; font-weight: bold; }
.text-red { color: #f56c6c; font-weight: bold; }
.card-header { font-weight: bold; }
.image-container { text-align: center; }
.detail-image { max-width: 100%; height: 200px; object-fit: contain; border-radius: 4px; }
.image-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
.image-item { text-align: center; }
.margin-top { margin-top: 16px; }
.dialog-footer { text-align: right; }

.summary-card { margin-bottom: 20px; }
.summary-item { padding: 8px 0; text-align: center; }
.summary-label { color: #909399; font-size: 13px; }
.summary-value { font-size: 22px; font-weight: bold; }

.point-list { margin-top: 5px; }
.point-card { margin-bottom: 16px; }
.point-header { display: flex; justify-content: space-between; align-items: center; font-weight: bold; }
.point-index { width: 24px; height: 24px; line-height: 24px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: #fff; border-radius: 50%; font-size: 12px; margin-right: 8px; text-align:center; }
.point-image-container { border: 1px solid #ebeef5; border-radius: 4px; padding: 8px; text-align:center; }
.point-image { max-width: 100%; height: 150px; object-fit: contain; }
.img-label { font-size: 12px; color: #909399; text-align: center; margin-bottom: 5px; }

.ai-result-box { margin-top: 12px; padding: 12px; border-radius: 6px; }
.ai-result-box.is-pass { background: #f0f9ff; border: 1px solid #b3e5fc; }
.ai-result-box.is-fail { background: #fef0f0; border: 1px solid #fbc4c4; }
.ai-result-title { font-size: 13px; font-weight: bold; margin-bottom: 6px; display: flex; align-items: center; }
.ai-result-title i { margin-right: 5px; }
.is-pass .ai-result-title { color: #67c23a; }
.is-fail .ai-result-title { color: #f56c6c; }
.ai-result-content { font-size: 13px; line-height: 1.6; color: #606266; }
</style>
